import { useEffect } from "react";

const OPEN_CLASS = "overlay-popup-open";
const DATA_ATTR = "data-overlay-popup-count";

function getCount(): number {
  const raw = document.body.getAttribute(DATA_ATTR);
  const count = Number(raw ?? "0");
  return Number.isFinite(count) && count > 0 ? count : 0;
}

function setCount(count: number) {
  document.body.setAttribute(DATA_ATTR, String(count));
  if (count > 0) {
    document.body.classList.add(OPEN_CLASS);
  } else {
    document.body.classList.remove(OPEN_CLASS);
    document.body.removeAttribute(DATA_ATTR);
  }
}

export function useOverlayPopupOpen(active: boolean) {
  useEffect(() => {
    if (!active) return;
    setCount(getCount() + 1);
    return () => {
      setCount(Math.max(0, getCount() - 1));
    };
  }, [active]);
}

